import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { getAuthItem } from '../../../../CommonMethods/authSession'
import { getValidatedRedirect } from '../../../../CommonMethods/redirectUtils'

const Home = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const userType = getAuthItem('user_type')

    useEffect(() => {
        const hasIdToken = getAuthItem('IdToken') !== null;
        const trustBrowserFlowActive = sessionStorage.getItem('trust_browser_flow_active') === 'true';
        // Don't navigate if trust browser flow is active (prevents premature navigation)
        if (hasIdToken && !trustBrowserFlowActive) {
            const searchParams = new URLSearchParams(location.search);
            const redirectPath = getValidatedRedirect(searchParams);
            const targetPath = redirectPath || (userType === 'monitor-user' ? '/manage-dashboard' : '/alerts-notifications');
            navigate(targetPath);
        } else if (!hasIdToken) {
            navigate('/');
        }
    }, [location.search, navigate, userType])

    return (
        <div></div>
    )
}

export default Home